import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';

import "./YourNestLogin.css";

import "../../styles/font.css";
import { TopMenuEmpty } from '../../component/TopMenuEmpty';
import { API_CONFIG } from '../../config/api';

export const YourNestLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async () => {
    try {
      const response = await fetch(`${API_CONFIG.MAIN}/admin_login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          admin_id: username,
          admin_pw: password
        })
      });
  
      if (!response.ok) throw new Error('로그인 실패');
      
      const data = await response.json();
      if (data.isSuccess) {
        document.cookie = `admin_id=${data.admin_id}; path=/;`;
        alert('로그인에 성공했습니다.');
        navigate('/yournest-admin');
      } else {
        alert('로그인에 실패했습니다.');
      }
    } catch (error) {
      console.error('로그인 오류:', error);
      alert('로그인에 실패했습니다.');
    }
  };
  

  return (
    <div className="tour-login">
      <div className="top-menu">
        <img 
          className="top-menu__logo-image" 
          src="icons/yournest_horizontal_logo.svg" 
          onClick={() => navigate('/')}
        />
      </div>
      <div className="login-area">
        <div className="login-area__title">관리자 로그인</div>
        
        <div className="login-area__form">
          <div className="login-area__id-block">
            <div className="login-area__id-text">아이디</div>
            <input 
              className="login-area__id-input" 
              placeholder="관리자 아이디" 
              value={username} 
              onChange={(e) => setUsername(e.target.value)} 
            />
          </div>
          <div className="login-area__pw-block">
            <div className="login-area__pw-text">비밀번호</div>
            <input 
              className="login-area__pw-input" 
              type="password" 
              placeholder="관리자 비밀번호" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
            />
          </div>
          <div className="login-area__btn-block" onClick={handleLogin}>
            <div className="login-area__btn-text">로그인</div>
          </div>
        </div>
      </div>

    </div>
  );
};
